import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {FaFacebookF, FaFacebookMessenger, FaInstagram, FaTelegramPlane, FaWhatsapp} from "react-icons/fa";
import {NavLink} from "react-router-dom";
import "../../assets/stylesheets/footer.css";
import HomeOpen from "./HomeOpen";
import i18n from 'i18next';
import {ContactInfoContext} from "../additional/ContactInfoContext";
import phoneIcon from "../../assets/image/phone.svg";
import mailIcon from "../../assets/image/gmail.svg";
import locationIcon from '../../assets/image/location.svg';

function Footer() {
    const {t, ready} = useTranslation(["home", "faq", "about", "rev", "choose", "legal", "ourspace", "seales", "freeconsult"]);
    const { contactInfo } = useContext(ContactInfoContext);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768); // or your breakpoint
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
    <footer>
        <div className="footer__area">
            <ul className="footer__menu-list">
                <div className="footbl">
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}`}
                            end
                        >
                            {t("home")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("about:aboutUs-url")}`}
                        >
                            {t("about:about")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/contacts`}
                        >
                            {t("contact")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("blog:blog-url")}`}
                        >
                            {t("blog:blog")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("rev:rev")}`}
                        >
                            {t("rev:review")}
                        </NavLink>
                    </li>
                </div>
                <div className="footbl">
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("choose:whyChooseUs")}`}
                        >
                            {t("choose:chooseUs")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("ourspace:ourspace-url")}`}
                        >
                            {t("ourspace:ourspace")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("faq:faq-url")}`}
                        >
                            {t("faq:faq")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("seales:sealesProces")}`}
                        >
                            {t("seales:salestext")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("legal:legalservice")}`}
                        >
                            {t("legal:attornay")}
                        </NavLink>
                    </li>
                    <li className="footer__menu-item">
                        <NavLink
                            className="footer__menu-link"
                            activeClassName="active"
                            to={`${i18n.language}/${t("freeconsult:freeCons")}`}
                        >
                            {t("freeconsult:freeConsult")}
                        </NavLink>
                    </li>
                </div>
                {isMobile && <div className="footbl footbl-contact">
                    <div className="footerMedia-Mobile">
                        {contactInfo.wpPhone && (
                            <a
                                href={`https://api.whatsapp.com/send?phone=${contactInfo.wpPhone}`}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaWhatsapp/>
                            </a>
                        )}
                        {contactInfo.facebookUrl && (
                            <a
                                href={contactInfo.facebookUrl}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookF/>
                            </a>
                        )}
                        {contactInfo.instagramUrl && (
                            <a
                                href={contactInfo.instagramUrl}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram/>
                            </a>
                        )}
                        {contactInfo.tgUsername && (
                            <a
                                href={`https://t.me/${contactInfo.tgUsername}`}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaTelegramPlane/>
                            </a>
                        )}
                        {contactInfo.messenger && (
                            <a
                                href={contactInfo.messenger}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookMessenger/>
                            </a>
                        )}
                    </div>
                </div> }

                <div className="footbl footbl-contact">
                    {contactInfo.address && (
                        <a href={`tel:${contactInfo.address}`} className="footer__menu-link">
                            <img src={locationIcon} alt="Location" style={{ marginRight: '8px' }} />
                            {contactInfo.address}
                        </a>
                    )}
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        {contactInfo.telPhone && (
                            <a href={`tel:${contactInfo.telPhone}`} className="footer__menu-link" style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={phoneIcon} alt="Phone" style={{ marginRight: '8px' }} />
                                {contactInfo.telPhone}
                            </a>
                        )}
                        {contactInfo.telPhone2 && (
                            <a href={`tel:${contactInfo.telPhone2}`} className="footer__menu-link" style={{ display: 'flex', alignItems: 'center' }}>
                                {contactInfo.telPhone2}
                            </a>
                        )}
                    </div>
                    {contactInfo.email && (

                        <a href={`mailto:${contactInfo.email}`} className="footer__menu-link">
                            <img src={mailIcon} alt="Phone" style={{ marginRight: '8px' }} />
                            {contactInfo.email}
                        </a>
                    )}
                    <div className="footerMedia">
                        {contactInfo.wpPhone && (
                            <a
                                href={`https://api.whatsapp.com/send?phone=${contactInfo.wpPhone}`}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaWhatsapp/>
                            </a>
                        )}
                        {contactInfo.facebookUrl && (
                            <a
                                href={contactInfo.facebookUrl}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookF/>
                            </a>
                        )}
                        {contactInfo.instagramUrl && (
                            <a
                                href={contactInfo.instagramUrl}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram/>
                            </a>
                        )}
                        {contactInfo.tgUsername && (
                            <a
                                href={`https://t.me/${contactInfo.tgUsername}`}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaTelegramPlane/>
                            </a>
                        )}
                        {contactInfo.messenger && (
                            <a
                                href={contactInfo.messenger}
                                target="_blank"
                                className="footer__social-icon"
                                rel="noopener noreferrer"
                            >
                                <FaFacebookMessenger/>
                            </a>
                        )}
                    </div>
                </div>
            </ul>
            <a href="https://www.websoft.am/" className="webSoft" target="_blank" rel="noopener noreferrer">
                <p >{t("company")}</p>
            </a>
            <p className="footer__end">
                Copyright ©2025 President and Fellows of REAL ESTATE AGENCY
            </p>
        </div>
        <HomeOpen/>
    </footer>
)
    ;
}

export default Footer;